import { makeStyles } from "@material-ui/core";

export const PaymentErrorStyles = makeStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#F6F6F7',
    },
    header: {
      display: 'flex',
      justifyContent: 'flex-start',
      width: '100%',
      padding: '16px 24px',
      borderBottom: '1px solid #e8e8e8',
    },
    logo: {
      height: '64px',
      width: '120px',
      objectFit: 'contain',
      marginLeft: '8px',
    },
    cardContainer: {
      width: '100%',
      maxWidth: '590px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: `calc(100vh - 200px)`,
    },
    card: {
      padding: '40px 30px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      border: '1px solid #eee',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.03)',
    },
    iconContainer: {
      width: 64,
      height: 64,
    },
    message: {
      color: 'var(--dark_blue)',
      fontSize: '16px',
      lineHeight: 1.5,
      margin: '24px 0px',
      height: 'unset !important',
      fontWeight: 600,
    },
    button: {
      backgroundColor: 'var(--accent-color) !important',
      color: 'white',
      fontWeight: 600,
      padding: '10px 24px',
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '16px',
      '&:hover, &:focus ': {
        backgroundColor: 'var(--accent-color) !important',
      },
    },
    footer: {
      fontSize: '14px',
      fontWeight: 600,
      color: 'var(--dark_blue)',
      marginTop: '12px',
    },
  });